export enum Brand {
  default = 'palmetto',
}

export const BrandLabels: Record<Brand, string> = {
  [Brand.default]: 'Palmetto',
};

export enum BrandKeyName {
  phone = 'phone',
  emailHelp = 'email-help',
  logoUrl = 'logo-url',
  baseSiteUrl = 'base-site-url',
}

export type BrandValues = Partial<Record<BrandKeyName, string | undefined>> & Record<string, string | undefined>;

export interface BrandDetails {
  brand: string;
  name: string;
  values: BrandValues;
}
